import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';
import { Button, Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from 'react-router-dom';
import TemplatesTable from '../components/TemplatesTable';
import { TemplatePagination } from "../types";
import { getTemplates } from "../api/templateAPI";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { setCurrentPage, setSearchText } from "../../../../redux/historicalSlice";
import 'bootstrap-icons/font/bootstrap-icons.css';
import Search from "../../../../components/Search"; 
import { ApiErrorResponse } from "../../../../types/ApiErrorResponse";

export default function TemplateList() {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [message, setMessage] = useState<string | undefined>(location.state?.message);
    const [messageError, setMessageError] = useState<string | undefined>('');
    const [templates, setTemplates] = useState<TemplatePagination>({
        page: 1,
        size: 0,
        totalPages: 0,
        totalRecords: 0,
        items: []
    });

    const [searchTerm, setSearchTerm] = useState('');

    const dispatch = useDispatch();
    const currentPage = useSelector((state: RootState) => state.historical.templates.currentPage);
    const itemsPerPage = useSelector((state: RootState) => state.historical.templates.itemsPerPage);
    const searchText = useSelector((state: RootState) => state.historical.templates.searchText);

    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setMessage(undefined);
            }, 10000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    const fetchTemplates = async (page = currentPage, size = itemsPerPage, search = searchTerm) => {
        getTemplates(page, size, search).then(data => {
            setTemplates(data);
        }).catch(error => {
            const fetchError = error as ApiErrorResponse;
            setMessageError(fetchError.message);
        });
    };


    useEffect(() => {
        fetchTemplates();
    }, [currentPage, itemsPerPage, searchTerm]);


    useEffect(() => {
        if (location.state?.message) {
            // Limpiamos el estado para que no se muestre al recargar
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, []);

    const handleClear = () =>  {
        dispatch(setCurrentPage({ table: "templates", page: 1 }));
        dispatch(setSearchText({ table: "templates", text: '' }));
        setSearchTerm('');

    }

    const handleSearchInput = () => {
        setSearchTerm(searchText || ''); 
        dispatch(setCurrentPage({ table: "templates", page: 1 }));
    };

    useEffect(() => {
        const initSearch = '';
        dispatch(setSearchText({ table: "templates", text: initSearch }));
        setSearchTerm('');
        fetchTemplates(1, itemsPerPage, initSearch);
    }, []);

    return (
        <>
            <Row className="mb-2 align-items-center justify-content-between">
                <Col xs={12} md>
                        <h2>{t("template:titleTemplate")}</h2>
                </Col>
                <Col xs={12} md="auto" className="d-flex align-items-center justify-content-end mt-2 mt-md-0">
                    <Button
                        variant="primary"
                        style={{ whiteSpace: "nowrap" }}
                        onClick={ () => navigate(`/admin/template/new-template`)}
                    >
                    {t("template:buttonNewTemplate")}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col className="text-center" xs={12} md={12}>
                {message && <div className="alert alert-success">{message}
                    <button
                        type="button"
                        className="btn-close btn-sm position-absolute top-0 end-0 m-2"
                        aria-label="Close"
                        onClick={() => setMessage(undefined)}
                    ></button>
                    </div>}
                </Col>
            </Row>
            <Row>
                <Col className="text-center" xs={12} md={12}>
                    {messageError && <div className="alert alert-danger">{messageError}
                        <button
                            type="button"
                            className="btn-close btn-sm position-absolute top-0 end-0 m-2"
                            aria-label="Close"
                            onClick={() => setMessageError(undefined)}
                        ></button>
                    </div>}
                </Col>
            </Row>
            <Row className="mb-2">
                <Col xs={12}>
                    <Search
                        searchText={searchText || ''}
                        onChange={(text) =>
                            dispatch(setSearchText({ table: "templates", text }))
                        }
                        onSearch={handleSearchInput}
                        onClear={handleClear}
                    />
                </Col>
            </Row>

            
            <TemplatesTable
                templatesData={templates}
                currentPage={currentPage}
                pageSize={itemsPerPage}
                totalPages={templates.totalPages}
                setMessage={setMessage}
            />                
        </>
    );
}


